'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');
var fscreen = _interopDefault(require('fscreen'));

var Fullscreen =
/*#__PURE__*/
function (_React$Component) {
  __chunk_1.inherits(Fullscreen, _React$Component);

  function Fullscreen(props) {
    var _this;

    __chunk_1.classCallCheck(this, Fullscreen);

    _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(Fullscreen).call(this, props));
    _this.detectFullscreen = _this.detectFullscreen.bind(__chunk_1.assertThisInitialized(_this));
    _this.enterFullscreen = _this.enterFullscreen.bind(__chunk_1.assertThisInitialized(_this));
    _this.leaveFullscreen = _this.leaveFullscreen.bind(__chunk_1.assertThisInitialized(_this));
    return _this;
  }

  __chunk_1.createClass(Fullscreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      fscreen.addEventListener('fullscreenchange', this.detectFullscreen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      fscreen.removeEventListener('fullscreenchange', this.detectFullscreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleProps(this.props);
    }
  }, {
    key: "handleProps",
    value: function handleProps(props) {
      var enabled = fscreen.fullscreenElement;

      if (enabled && !props.enabled) {
        this.leaveFullscreen();
      } else if (!enabled && props.enabled) {
        this.enterFullscreen();
      }
    }
  }, {
    key: "detectFullscreen",
    value: function detectFullscreen() {
      if (this.props.onChange) {
        this.props.onChange(Boolean(fscreen.fullscreenElement));
      }
    }
  }, {
    key: "enterFullscreen",
    value: function enterFullscreen() {
      if (fscreen.fullscreenEnabled) {
        fscreen.requestFullscreen(this.node);
      }
    }
  }, {
    key: "leaveFullscreen",
    value: function leaveFullscreen() {
      if (fscreen.fullscreenEnabled) {
        fscreen.exitFullscreen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement("div", {
        className: this.props.className,
        ref: function ref(node) {
          return _this2.node = node;
        },
        style: this.props.enabled ? {
          height: '100%',
          width: '100%'
        } : undefined
      }, this.props.children);
    }
  }]);

  return Fullscreen;
}(React__default.Component);
Fullscreen.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func
};
Fullscreen.defaultProps = {
  enabled: false
};

exports.Fullscreen = Fullscreen;
//# sourceMappingURL=fullscreen.js.map
